import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ui-components/components/modal';
import style from './style.module.less';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import AsModal from '../../../components/as-modal';

const DeleteReportingCategoryModal = ({ onClose, onDelete }) => {
  return (
    <Modal className={style.modal} size='custom'>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...messages.deleteModalHeader} />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style.warning}>
          <FormattedMessage {...messages.deleteModalWarning} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onDelete} theme='danger'>
          <FormattedMessage {...messages.deleteModalConfirmation} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteReportingCategoryModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AsModal(DeleteReportingCategoryModal);
